/* Shared by the storefront, checkout UI and Shopify validation Function. */
(function (root, factory) {
  const policy = factory();
  if (typeof module === 'object' && module.exports) module.exports = policy;
  if (root) root.PITBPickupPolicy = policy;
})(typeof window === 'undefined' ? null : window, function () {
  const DAY_MS = 86400000;
  // Lead time in days before / from the 8 PM SGT cutoff. Defaults are today + 2 / today + 3; a storefront or checkout surface can override them with
  // globalThis.PITB_PICKUP_LEAD_DAYS = { before: 2, after: 3 } (read at call time).
  const DEFAULT_LEAD_DAYS = { before: 2, after: 3 };

  function leadDays(afterCutoff) {
    const cfg = (typeof globalThis !== 'undefined' && globalThis.PITB_PICKUP_LEAD_DAYS) || {};
    const key = afterCutoff ? 'after' : 'before';
    const value = Number(cfg[key]);
    return Number.isInteger(value) && value >= 0 ? value : DEFAULT_LEAD_DAYS[key];
  }

  function isIsoDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
    const date = new Date(value + 'T00:00:00Z');
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
  }

  function earliestFromLocalTime(date, afterCutoff) {
    if (!isIsoDate(date) || typeof afterCutoff !== 'boolean') return '';
    return new Date(Date.parse(date + 'T00:00:00Z') + leadDays(afterCutoff) * DAY_MS)
      .toISOString().slice(0, 10);
  }

  function earliestPickupDate(now = new Date()) {
    // Singapore is UTC+8 year-round, independent of the customer's timezone.
    const sgt = new Date(now.getTime() + 8 * 60 * 60 * 1000);
    return earliestFromLocalTime(sgt.toISOString().slice(0, 10), sgt.getUTCHours() >= 20);
  }

  return { isIsoDate, earliestFromLocalTime, earliestPickupDate };
});
